import { hoursToMinutes, minutesToHours } from '@acme/common'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { Registro } from 'service/api'
import { match } from 'ts-pattern'

export const SaldoDiarioCell: React.FC<GridCellParams<Registro[]>> = ({
    row,
}) => {
    const saldo = hoursToMinutes(row.horasExtra) - hoursToMinutes(row.faltas)

    return match(saldo)
        .when(
            x => x === 0,
            () => <span className="text-muted-foreground">+00:00</span>,
        )
        .when(
            x => x < 0,
            x => (
                <span className="font-semibold text-error">
                    -{minutesToHours(Math.abs(x))}
                </span>
            ),
        )
        .otherwise(x => (
            <span className="font-semibold text-success">
                +{minutesToHours(x)}
            </span>
        ))
}
